import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import AdminSidebar from "../shared/AdminSidebar";

const ModifierLeBudget = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const budgetToEdit = location.state?.budget;
  // PHP backend base URL from .env
  const phpBase = (process.env.REACT_APP_BASE_URL || "").replace(/\/$/, "");

  const [appelation, setAppelation] = useState(
    budgetToEdit?.budget_appellation || budgetToEdit?.appellation || ""
  );
  const [creationDate, setCreationDate] = useState(
    budgetToEdit?.budget_date_creation || budgetToEdit?.date_creation || new Date().toISOString().substring(0, 10)
  );
  const [sectionAppelation, setSectionAppelation] = useState("");
  const [sectionDate, setSectionDate] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [groupAppelation, setGroupAppelation] = useState("");
  const [groupSection, setGroupSection] = useState("");
  const [categorieAppelation, setCategorieAppelation] = useState("");
  const [categorieGroupment, setCategorieGroupment] = useState("");

  const [sections, setSections] = useState([]);
  const [groups, setGroups] = useState([]);
  const [categories, setCategories] = useState([]);

  const [isSectionFormOpen, setIsSectionFormOpen] = useState(false);
  const [isGroupFormOpen, setIsGroupFormOpen] = useState(false);
  const [isCategorieFormOpen, setIsCategorieFormOpen] = useState(false);

  const [editingSectionIndex, setEditingSectionIndex] = useState(null);
  const [editingGroupIndex, setEditingGroupIndex] = useState(null);
  const [editingCategorieIndex, setEditingCategorieIndex] = useState(null);

  useEffect(() => {
    if (budgetToEdit) {
      const baseUrl = phpBase;

      // Fetch available sections, groupements, and categories for the selected budget
      axios.get(`${baseUrl}/getSections.php`).then((response) => {
        const filteredSections = response.data.filter(
          (section) => section.ID_budget_parametre === budgetToEdit.id
        );
        setSections(Array.isArray(filteredSections) ? filteredSections : []);
        console.log("Fetched sections:", filteredSections);
      });

      axios.get(`${baseUrl}/getGroupements.php`).then((response) => {
        const filteredGroups = response.data.filter(
          (group) => group.ID_budget_parametre === budgetToEdit.id
        );
        setGroups(Array.isArray(filteredGroups) ? filteredGroups : []);
        console.log("Fetched groupements:", filteredGroups);
      });

      axios.get(`${baseUrl}/getCategories.php`).then((response) => {
        const filteredCategories = response.data.filter(
          (categorie) => categorie.ID_budget_parametre === budgetToEdit.id
        );
        setCategories(
          Array.isArray(filteredCategories) ? filteredCategories : []
        );
        console.log("Fetched categories:", filteredCategories);
      });
    }
  }, [budgetToEdit]);

  const handleAppelationChange = (e) => {
    setAppelation(e.target.value);
  };

  const handleSectionAppelationChange = (e) => {
    setSectionAppelation(e.target.value);
  };

  const handleGroupAppelationChange = (e) => {
    setGroupAppelation(e.target.value);
  };

  const handleGroupSectionChange = (e) => {
    setGroupSection(e.target.value);
  };

  const handleCategorieAppelationChange = (e) => {
    setCategorieAppelation(e.target.value);
  };

  const handleCategorieGroupmentChange = (e) => {
    setCategorieGroupment(e.target.value);
  };

  const handleOpenSectionForm = () => {
    setIsSectionFormOpen(true);
    setSectionAppelation("");
    setSectionDate(new Date().toISOString().substring(0, 10));
    setEditingSectionIndex(null); // Reset edit mode
  };

  const handleOpenGroupForm = () => {
    setIsGroupFormOpen(true);
    setGroupAppelation("");
    setGroupSection("");
    setEditingGroupIndex(null); // Reset edit mode
  };

  const handleOpenCategorieForm = () => {
    setIsCategorieFormOpen(true);
    setCategorieAppelation("");
    setCategorieGroupment("");
    setEditingCategorieIndex(null); // Reset edit mode
  };

  const handleSectionSubmit = (e) => {
    e.preventDefault();
    if (editingSectionIndex !== null) {
      const updatedSections = sections.map((section, index) =>
        index === editingSectionIndex
          ? {
              ...section,
              appellation: sectionAppelation,
              date_creation: sectionDate,
            }
          : section
      );
      setSections(updatedSections);
    } else {
      const newSection = {
        appellation: sectionAppelation,
        date_creation: sectionDate,
      };
      setSections([...sections, newSection]);
    }
    setIsSectionFormOpen(false);
  };

  const handleGroupSubmit = (e) => {
    e.preventDefault();
    if (editingGroupIndex !== null) {
      const updatedGroups = groups.map((group, index) =>
        index === editingGroupIndex
          ? {
              ...group,
              appellation: groupAppelation,
              ID_ligne_budget_section: groupSection,
            }
          : group
      );
      setGroups(updatedGroups);
    } else {
      const newGroup = {
        appellation: groupAppelation,
        ID_ligne_budget_section: groupSection,
        date_creation: new Date().toISOString().substring(0, 10),
      };
      setGroups([...groups, newGroup]);
    }
    setIsGroupFormOpen(false);
  };

  const handleCategorieSubmit = (e) => {
    e.preventDefault();
    if (editingCategorieIndex !== null) {
      const updatedCategories = categories.map((categorie, index) =>
        index === editingCategorieIndex
          ? {
              ...categorie,
              appellation: categorieAppelation,
              ID_ligne_budget_groupement: categorieGroupment,
            }
          : categorie
      );
      setCategories(updatedCategories);
    } else {
      const newCategorie = {
        appellation: categorieAppelation,
        ID_ligne_budget_groupement: categorieGroupment,
        date_creation: new Date().toISOString().substring(0, 10),
      };
      setCategories([...categories, newCategorie]);
    }
    setIsCategorieFormOpen(false);
  };

  const handleDeleteSection = (index) => {
    const updatedSections = sections.filter((_, i) => i !== index);
    setSections(updatedSections);
  };

  const handleDeleteGroup = (index) => {
    const updatedGroups = groups.filter((_, i) => i !== index);
    setGroups(updatedGroups);
  };

  const handleDeleteCategorie = (index) => {
    const updatedCategories = categories.filter((_, i) => i !== index);
    setCategories(updatedCategories);
  };

  const handleEditSection = (index) => {
    setEditingSectionIndex(index);
    const section = sections[index];
    setSectionAppelation(section.appellation);
    setSectionDate(section.date_creation);
    setIsSectionFormOpen(true);
  };

  const handleEditGroup = (index) => {
    setEditingGroupIndex(index);
    const group = groups[index];
    setGroupAppelation(group.appellation);
    setGroupSection(group.ID_ligne_budget_section); // Set the section ID
    setIsGroupFormOpen(true);
  };

  const handleEditCategorie = (index) => {
    setEditingCategorieIndex(index);
    const categorie = categories[index];
    setCategorieAppelation(categorie.appellation);
    setCategorieGroupment(categorie.ID_ligne_budget_groupement); // Set the groupement ID
    setIsCategorieFormOpen(true);
  };

  const handleSaveAll = () => {
    const today = new Date().toISOString().substring(0, 10);
    const finalAppelation = (appelation || "").trim() || budgetToEdit?.budget_appellation || budgetToEdit?.appellation || "";
    const finalDate = (creationDate || "").trim() || today;
    if (!finalAppelation) {
      alert("Veuillez saisir l'appellation du budget.");
      return;
    }
    const updatedBudgetData = {
      budget_id: budgetToEdit.id, // Include the budget ID
      appelation: finalAppelation,
      date_creation: finalDate,
      sections: sections.map((section) => {
        const { ID_ligne_budget_section, ...rest } = section;
        const payload = ID_ligne_budget_section
          ? { ID_ligne_budget_section, ...rest }
          : rest;
        return { ...payload, date_creation: payload.date_creation || today };
      }),
      groups: groups.map((group) => {
        const { ID_ligne_budget_groupement, ...rest } = group;
        const payload = ID_ligne_budget_groupement
          ? { ID_ligne_budget_groupement, ...rest }
          : rest;
        return { ...payload, date_creation: payload.date_creation || today };
      }),
      categories: categories.map((categorie) => {
        const { ID_ligne_budget_categorie, ...rest } = categorie;
        const payload = ID_ligne_budget_categorie
          ? { ID_ligne_budget_categorie, ...rest }
          : rest;
        return { ...payload, date_creation: payload.date_creation || today };
      }),
    };

    console.log("Sending updated data:", updatedBudgetData);

    // Send updated data to the backend
    axios
      .post(`${phpBase}/updateBudget.php`, updatedBudgetData)
      .then((response) => {
        const ok = response?.data?.success === true || response?.status === 200;
        if (!ok) {
          console.error("Update failed:", response?.data);
          alert(response?.data?.error || "Échec de la mise à jour du budget.");
          return;
        }
        console.log("Budget updated successfully:", response.data);
        alert("Budget mis à jour avec succès !");
        navigate("/parametre"); // Redirect to the main budget list page
      })
      .catch((error) => {
        console.error("Error updating budget:", error);
        const msg = error?.response?.data?.error || error.message || "Failed to update budget.";
        alert(msg);
      });
  };

  if (!budgetToEdit) {
    return <p>No budget data available to edit.</p>;
  }

  return (
    <div className="d-flex">
      <AdminSidebar />
      <div className="content-add">
        {/* Form for Budget */}
        <form className="budget-form">
          <div>
            <label htmlFor="appelation" style={{ color: "black" }}>
              Appelation Budget:
            </label>
            <input
              type="text"
              id="appelation"
              value={appelation}
              onChange={handleAppelationChange}
              placeholder="Enter budget name"
            />
          </div>
          <div>
            <label htmlFor="creationDate" style={{ color: "black" }}>
              Date de Création:
            </label>
            <input
              type="date"
              id="creationDate"
              value={creationDate}
              readOnly
            />
          </div>
        </form>
        {/* First Table Section */}
        <div className="table-section">
          <div className="table-header">
            <button onClick={handleOpenSectionForm}>Nouveau Section</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Appelation Section</th>
                <th>Date de Création</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {sections.map((section, index) => (
                <tr key={index}>
                  <td>{section.ID_ligne_budget_section}</td>
                  <td>{section.appellation}</td>
                  <td>{section.date_creation}</td>
                  <td>
                    <button onClick={() => handleDeleteSection(index)}>
                      Supprimer
                    </button>
                    <button onClick={() => handleEditSection(index)}>
                      Modifier
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {isSectionFormOpen && (
            <form className="group-form" onSubmit={handleSectionSubmit}>
              <h3>
                {editingSectionIndex !== null
                  ? "Modifier Section"
                  : "Ajouter Section"}
              </h3>
              <div>
                <label htmlFor="sectionAppelation" style={{ color: "black" }}>
                  Appelation Section:
                </label>
                <input
                  type="text"
                  id="sectionAppelation"
                  value={sectionAppelation}
                  onChange={handleSectionAppelationChange}
                  placeholder="Enter Section Nom"
                />
              </div>
              <div>
                <label htmlFor="creationDate" style={{ color: "black" }}>
                  Date de Création:
                </label>
                <input
                  type="date"
                  id="creationDate"
                  value={sectionDate}
                  readOnly
                />
              </div>
              <button type="submit">
                {editingSectionIndex !== null ? "Modifier" : "Ajouter"}
              </button>
            </form>
          )}
        </div>
        {/* Second Table Groupement */}
        <div className="table-section">
          <div className="table-header">
            <button onClick={handleOpenGroupForm}>Nouveau Groupement</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Appelation Groupement</th>
                <th>Appelation Section</th>
                <th>Date de Création</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group, index) => {
                const section = sections.find(
                  (section) =>
                    section.ID_ligne_budget_section ===
                    group.ID_ligne_budget_section
                );
                return (
                  <tr key={index}>
                    <td>{group.ID_ligne_budget_groupement}</td>
                    <td>{group.appellation}</td>
                    <td>{section ? section.appellation : "N/A"}</td>
                    <td>{group.date_creation}</td>
                    <td>
                      <button onClick={() => handleDeleteGroup(index)}>
                        Supprimer
                      </button>
                      <button onClick={() => handleEditGroup(index)}>
                        Modifier
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {isGroupFormOpen && (
            <form className="group-form" onSubmit={handleGroupSubmit}>
              <h3>
                {editingGroupIndex !== null
                  ? "Modifier Groupement"
                  : "Ajouter Groupement"}
              </h3>
              <div>
                <label htmlFor="groupAppelation" style={{ color: "black" }}>
                  Appelation Groupement:
                </label>
                <input
                  type="text"
                  id="groupAppelation"
                  value={groupAppelation}
                  onChange={handleGroupAppelationChange}
                  placeholder="Enter group name"
                />
              </div>
              <div>
                <label htmlFor="groupSection" style={{ color: "black" }}>
                  Appelation Section:
                </label>
                <select
                  id="groupSection"
                  value={groupSection}
                  onChange={handleGroupSectionChange}
                >
                  <option value="">Select Section</option>
                  {sections.map((section) => (
                    <option
                      key={section.ID_ligne_budget_section}
                      value={section.ID_ligne_budget_section}
                    >
                      {section.appellation}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="creationDate" style={{ color: "black" }}>
                  Date de Création:
                </label>
                <input
                  type="date"
                  id="creationDate"
                  value={new Date().toISOString().substring(0, 10)}
                  readOnly
                />
              </div>
              <button type="submit">
                {editingGroupIndex !== null ? "Modifier" : "Ajouter"}
              </button>
            </form>
          )}
        </div>
        {/* Third Table Categorie */}
        <div className="table-section">
          <div className="table-header">
            <button onClick={handleOpenCategorieForm}>Nouveau Categorie</button>
          </div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Appelation Categorie</th>
                <th>Appelation Groupement</th>
                <th>Date de Création</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((categorie, index) => {
                const group = groups.find(
                  (group) =>
                    group.ID_ligne_budget_groupement ===
                    categorie.ID_ligne_budget_groupement
                );
                return (
                  <tr key={index}>
                    <td>{categorie.ID_ligne_budget_categorie}</td>
                    <td>{categorie.appellation}</td>
                    <td>{group ? group.appellation : "N/A"}</td>
                    <td>{categorie.date_creation}</td>
                    <td>
                      <button onClick={() => handleDeleteCategorie(index)}>
                        Supprimer
                      </button>
                      <button onClick={() => handleEditCategorie(index)}>
                        Modifier
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {isCategorieFormOpen && (
            <form className="group-form" onSubmit={handleCategorieSubmit}>
              <h3>
                {editingCategorieIndex !== null
                  ? "Modifier Categorie"
                  : "Ajouter Categorie"}
              </h3>
              <div>
                <label htmlFor="categorieAppelation" style={{ color: "black" }}>
                  Appelation Categorie:
                </label>
                <input
                  type="text"
                  id="categorieAppelation"
                  value={categorieAppelation}
                  onChange={handleCategorieAppelationChange}
                  placeholder="Enter category name"
                />
              </div>
              <div>
                <label htmlFor="categorieGroupment" style={{ color: "black" }}>
                  Appelation Groupement:
                </label>
                <select
                  id="categorieGroupment"
                  value={categorieGroupment}
                  onChange={handleCategorieGroupmentChange}
                >
                  <option value="">Select Groupement</option>
                  {groups.map((group) => (
                    <option
                      key={group.ID_ligne_budget_groupement}
                      value={group.ID_ligne_budget_groupement}
                    >
                      {group.appellation}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="creationDate" style={{ color: "black" }}>
                  Date de Création:
                </label>
                <input
                  type="date"
                  id="creationDate"
                  value={new Date().toISOString().substring(0, 10)}
                  readOnly
                />
              </div>
              <button type="submit">
                {editingCategorieIndex !== null ? "Modifier" : "Ajouter"}
              </button>
            </form>
          )}
        </div>
        <button
          type="submit"
          className="enregistrer-button"
          onClick={handleSaveAll}
        >
          Enregistrer
        </button>
      </div>
    </div>
  );
};

export default ModifierLeBudget;
